import { IBanner } from '@common/interfaces/banner.interface';


export const BANNER_LIST: IBanner[] = [
  {
    text: {
      title: "",
      subtitle: ""
    },
    buttons: {
      primary: {
        text: 'Ver catálogo',
        href: 'https://firebasestorage.googleapis.com/v0/b/hbk-prd.appspot.com/o/RPGO%2FCATALOGOS%2FpdfCatalogoSC?alt=media&token=384ab649-4e5f-4d9a-8de3-e3bc03ec3750',
      }
    },
    image: 'banner-home-catalogo-jul.png',
    tag: 'banner-home-catalogo-jul',
    sections: [
      {
        section: 'home',
        order: 0
      },
      {
        section: 'categorias',
        order: 0
      },
      {
        section: 'canjes',
        order: 0
      }
    ]
  },
  // Cumpleaños
  {
    text: {
      title: "",
      subtitle: ""
    },
    buttons: {
      primary: {
        text: 'Descúbrelo aquí',
        href: 'clientes-prime',
      }
    },
    image: 'banner-home-cumpleanios-jul.png',
    tag: 'banner-home-cumpleanios-jul',
    sections: [
      {
        section: 'categorias',
        order: 2
      },
      {
        section: 'home',
        order: 3
      }
    ]
  },
  // Despacho
  {
    text: {
      title: "",
      subtitle: ""
    },
    buttons: {
      primary: {
        text: 'Usar mi cupón',
        href: 'https://simple.ripley.com.pe',
      }
    },
    image: 'banner-home-despacho-jul.png',
    tag: 'banner-home-despacho-jul',
    sections: [
      {
        section: 'categorias',
        order: 3
      },
      {
        section: 'home',
        order: 4
      }
    ]
  },
  // Restofans
  {
    text: {
      title: "",
      subtitle: ""
    },
    buttons: {
      primary: {
        text: 'Ver más',
        href: 'https://www.bancoripley.com.pe/promociones/default.html#nav-restofans',
      }
    },
    image: 'banner-home-restofans-jul.png',
    tag: 'banner-home-restofans-jul',
    sections: [
      {
        section: 'categorias',
        order: 4
      },
      {
        section: 'home',
        order: 5
      }
    ]
  },
  // Gift Card
  {
    text: {
      title: "",
      subtitle: ""
    },
    buttons: {
      primary: {
        text: 'Canjear ahora',
        href: 'https://bancaenlinea.bancoripley.com.pe/home/ripley-points',
      }
    },
    image: 'banner-home-giftcard-jul.png',
    tag: 'banner-home-giftcard-jul',
    sections: [
      {
        section: 'canjes',
        order: 3
      }
    ]
  },
  // Experiencias
  {
    text: {
      title: "",
      subtitle: ""
    },
    buttons: {
      primary: {
        text: 'Ver más',
        href: 'https://bancaenlinea.bancoripley.com.pe/home/ripley-points',
      }
    },
    image: 'banner-canje-experiencias-jul.png',
    tag: 'banner-canje-experiencias-jul',
    sections: [
      {
        section: 'canjes',
        order: 4
      }
    ]
  },
  // Latam Regular
  {
    text: {
      title: "",
      subtitle: ""
    },
    buttons: {
      primary: {
        text: 'Canjear ahora',
        href: 'canje-latam-pass',
      }
    },
    image: 'banner-home-latam-regular-jul.png',
    tag: 'banner-home-latam-regular-jul',
    sections: [
      {
        section: 'canjes',
        order: 5
      }
    ]
  },

];
